<template>
    <section>
        <div id="related-item" class="modal-mask" key="relatedItem">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <div class="modalBody">
                        <AddToBasket :action="action"></AddToBasket>
                        <div class="btnCloseModalBasket">
                            <button class="btn uppercase" @click="close">{{ $t("abonnement.close") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
//    import Vue from 'vue'
import "whatwg-fetch";
import Diffusion from "./Diffusion";
import httpService from "../../components/service";
import AddToBasket from "./AddToBasket";

export default {
    components: {
        Diffusion,
        AddToBasket
    },
    data() {
        return {
            application: [{ name: "Catalogue" }, { name: "Planogramme" }, { name: "Book PDF Catalogue" }],
            diffusion: false,
            facturation: {}
        };
    },
    props: ["action"],
    watch: {},
    methods: {
        modalClose(close) {
            this.diffusion = close;
        },
        close() {
            this.$emit("hideBasketModal", false);
        }
    },
    computed: {},
    created() {
        httpService.get("/admin/subscription/detail").then(response => {
            this.facturation = response;
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}

#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }
        .btnCloseModalBasket {
            position: relative;
            top: -51px;
            float: right;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 380px;
        min-height: 200px;
        border-radius: 4px;
        @extend %second-background;
        padding: 10px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalBasket.vue?7f28bf58